import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=610e48c4&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=610e48c4&prod&scoped=true&lang=css"
import style1 from "./Calendar.vue?vue&type=style&index=1&id=610e48c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e48c4",
  null
  
)

export default component.exports